import React, { useEffect } from 'react';

import { EventName } from 'enums';
import { PaymentCardViewProps } from 'types';
import { eventUtils } from 'utils';

import { SqFormFields } from '../SqFormFields';

export const SqPaymentCard: React.FC<PaymentCardViewProps> = ({
  paymentFormValues,
  onPaymentFormValuesChange,
  customerFields,
}) => {
  useEffect(() => {
    eventUtils.trackEvent({ event: EventName.OpenCustomerDataForm });
  }, []);

  return (
    <div className="tw-flex tw-flex-col tw-w-full tw-gap-[10px]">
      <SqFormFields
        fields={customerFields}
        paymentFormValues={paymentFormValues}
        onPaymentFormValuesChange={onPaymentFormValuesChange}
      />
    </div>
  );
};
